export const WebSocketConnector = 'WebSocketConnector';
export const SyncRegistry = 'SyncRegistry';
export const PlatformSyncDetector = 'PlatformSyncDetector';
export const LocalFilesystemCleaner = 'LocalFilesystemCleaner';
export const CommandQueueCleaner = 'CommandQueueCleaner';
